import { Component, OnInit, ViewChild } from "@angular/core";
import { InformeProductosService } from "src/app/servicios/informe-productos.service";
import { Observable, Subject } from "rxjs";
import { DataTableDirective } from "angular-datatables";
import { Utils } from "../../utils/utils";

@Component({
  selector: "app-informe-productos",
  templateUrl: "./informe-productos.component.html",
  styleUrls: ["./informe-productos.component.css"],
})
export class InformeProductosComponent implements OnInit {
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;

  dataFromFiltro: any;
  dataProducto = [];
  haveData = false;
  timeRunning = 0;
  dtTrigger = new Subject();

  loading = false;

  dtOptions: any = {
    pagingType: "full_numbers",
    scrollX: true,
    dom: "Bfrtip",
    order: [],
    buttons: [
      "colvis",
      {
        extend: "copyHtml5",

        exportOptions: {
          columns: ":visible",
        },
      },
      {
        extend: "excelHtml5",
        fileName: "ResumenRecorrido" + ".xlsx",
        exportOptions: {
          columns: ":visible",
        },
        //CharSet: "utf8",
        exportData: { decodeEntities: true },
      },
    ],
  };

  constructor(
    public servicioInformeProductos: InformeProductosService,
    public ruta: Utils
  ) {}

  ngOnInit() {
    this.ruta.setRuta();
  }

  dataFiltro(data) {
    console.log(data);
    this.dataFromFiltro = JSON.parse(data);
    this.cargarData();
  }

  cargarData() {
    let producto: any;
    if (!this.dataFromFiltro.producto) {
      producto = " ";
    } else {
      producto = this.dataFromFiltro.producto;
    }

    let grupo = this.dataFromFiltro.grupo;
    let linea = this.dataFromFiltro.linea;
    let marca = this.dataFromFiltro.marca;

    this.loading = true;

    this.servicioInformeProductos
      .getProductos(producto, grupo, linea, marca)
      .subscribe((result) => {
        this.dataProducto = result;
        if (result.length > 0) {
          this.haveData = true;
        }

        if (this.timeRunning == 0) {
          this.dtTrigger.next();
        } else {
          this.reRender();
        }
        this.timeRunning++;
        this.loading = false;
      });
  }

  reRender() {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again

      this.dtTrigger.next();
    });
  }
}
